<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("notification") }}</h3>
    <v-card class="pa-4" style="margin-bottom: 30px">
      <h3 class="small-title">{{ $t("notification") }}</h3>
      <div class="d-flex notification-card" style="gap: 25px">
        <div class="left-about-section">
          <p class="ptitle">
            {{ $t("yourPhoneAccept") }}
          </p>
          <div v-for="(item, idx) in desserts.phoneNumber" :key="idx">
            <a class="phone" :href="`tel:+${item}`">{{
              item ? "+" + item : ""
            }}</a>
          </div>
        </div>
        <div class="vl"></div>
        <div class="right-about-section">
          <p class="ptitle">{{ $t("telegramBotLink") }}</p>
          <div class="telegram-link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M14 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.89543 15.1046 0 14 0Z"
                fill="#2BBBDE"
              />
              <path
                d="M7.13898 8.89345L7.00648 10.7549C7.07769 10.7556 7.14809 10.7397 7.21218 10.7087C7.27627 10.6776 7.33232 10.6322 7.37598 10.5759L8.26348 9.72595L10.103 11.0729C10.4405 11.2609 10.678 11.1619 10.769 10.7624L11.977 5.10695C12.084 4.60695 11.7965 4.41345 11.468 4.53545L4.37148 7.24995C3.88698 7.43795 3.89448 7.70795 4.28898 7.83045L6.10348 8.39695L10.318 5.75995C10.518 5.62845 10.6965 5.70145 10.5485 5.83245L7.13898 8.89345Z"
                fill="white"
              />
            </svg>
            <a class="link" target="_blank" :href="desserts.tgBotUrl">{{
              desserts.tgBotName
            }}</a>
          </div>
        </div>
      </div>
    </v-card>
    <div>
      <div class="notification-page">
        <!--        <div class="division_main">-->
        <!--          <validation-observer v-slot="{ handleSubmit }" ref="formObs">-->
        <!--            <v-card-title class="px-0">{{ $t("notification") }}</v-card-title>-->
        <!--            <form @submit.prevent="handleSubmit(submit)">-->
        <!--              <div class="py-2">-->
        <!--                <custom-input-text-->
        <!--                  :label="$t('title')"-->
        <!--                  rules="required"-->
        <!--                  class="user_input no-margin"-->
        <!--                  v-model="notification.title"-->
        <!--                ></custom-input-text>-->
        <!--              </div>-->
        <!--              <div class="py-2">-->
        <!--                <custom-text-textarea-->
        <!--                  rules="required"-->
        <!--                  class="user_input no-margin"-->
        <!--                  v-model="notification.comment"-->
        <!--                  :label="$t('comment')"-->
        <!--                ></custom-text-textarea>-->
        <!--              </div>-->
        <!--              <div class="text-right">-->
        <!--                <v-btn color="primary" :loading="loading" type="submit">{{-->
        <!--                  $t("send")-->
        <!--                }}</v-btn>-->
        <!--              </div>-->
        <!--            </form>-->
        <!--          </validation-observer>-->
        <!--        </div>-->
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="desserts.items"
          :single-select="singleSelect"
          :items-per-page="limit"
          item-key="id"
          show-select
          class="elevation-1"
          :hide-default-footer="true"
          :loading="paginationLoading"
        >
          <template v-slot:top>
            <div class="d-flex global_actions">
              <div @click="makeReadMessages">
                <v-icon>mdi-email-open-outline</v-icon>
              </div>
            </div>
          </template>
          <template v-slot:item.title="{ item }">
            <v-chip
              @click="openNotificationModal(item.id)"
              :color="item.read === 'true' ? 'gray' : 'primary'"
              dark
              >{{ item[`title_${$i18n.locale}`] }}</v-chip
            >
          </template>
          <template v-slot:item.body="{ item }">
            <span
              style="font-weight: 700"
              :class="{ readNotification: item.read === 'true' }"
              @click="$refs.notificationDialog.open(item.id)"
              >{{ item[`body_${$i18n.locale}`] }}</span
            >
          </template>
          <template v-slot:item.sentAt="{ item }">
            <span
              style="font-weight: 700"
              :class="{ readNotification: item.read === 'true' }"
            >
              {{ item.sentAt }}
            </span>
          </template>
          <template v-slot:footer>
            <v-pagination
              v-if="Math.ceil(total / limit) > 1"
              class="mt-4 pb-4"
              v-model="page"
              :length="Math.ceil(total / limit)"
              @input="next"
            ></v-pagination>
          </template>
        </v-data-table>
      </div>
      <div class="notificationList_container">
        <div class="notification_container"></div>
      </div>
    </div>
    <NotificationDialog ref="notificationDialog" />
  </div>
</template>

<!--<script>-->
<!--export default {-->
<!--  data() {-->
<!--    return {-->
<!--      loading: false,-->
<!--      notification: {-->
<!--        title: null,-->
<!--        comment: null,-->
<!--      },-->
<!--    };-->
<!--  },-->
<!--  methods: {-->
<!--    async submit() {-->
<!--      this.loading = true;-->
<!--      try {-->
<!--        await this.$http.post("notification/send-every-one", this.notification);-->
<!--        const { formObs } = this.$refs;-->
<!--        this.notification = {-->
<!--          title: null,-->
<!--          comment: null,-->
<!--        };-->
<!--        formObs.reset();-->
<!--        this.setSuccess({ text: this.$t("successfullySent") });-->
<!--      } catch (e) {-->
<!--        this.setResponseError({ error: e });-->
<!--      } finally {-->
<!--        this.loading = false;-->
<!--      }-->
<!--    },-->
<!--  },-->
<!--};-->
<!--</script>-->

<script>
import NotificationDialog from "@/components/notification/NotificationDialog";
import SocketService from "@/services/SocketService";
export default {
  data() {
    return {
      limit: 10,
      page: 1,
      total: 0,
      notReaded: 0,
      singleSelect: false,
      paginationLoading: false,
      selected: [],
      desserts: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("name"),
          align: "start",
          sortable: false,
          value: "body",
        },
        { text: this.$t("title"), value: "title", sortable: false },
        { text: this.$t("date"), value: "sentAt" },
      ];
    },
  },
  components: {
    NotificationDialog,
  },
  methods: {
    async openNotificationModal(id) {
      await this.$refs.notificationDialog.open(id);
      try {
        await this.$http.post("notification/mark-as-read", [id]);
        await this.getNotificationList();
      } catch (e) {
        console.log(e);
      }
    },
    async connectWebSocket() {
      try {
        const client = await SocketService.promiseConnect();
        console.log("CLIENT", client);
        client.subscribe("/user/inventarization/request", (data) => {
          data = JSON.parse(data.body);
          console.log("ws data", data);
          this.$notify({ text: "New Message", type: "success" });
          this.getNotificationList();
        });
      } catch (e) {
        console.log("ws error", e);
      }
    },
    async makeReadMessages() {
      if (!this.selected.length) return;
      try {
        await this.$http.post(
          "notification/mark-as-read",
          this.selected.map((item) => item.id)
        );
        this.$notify({ text: "All Messages Readed", type: "success" });
        this.getNotificationList();
        this.selected = [];
      } catch (e) {
        this.$notify({ text: "Error", type: "error" });
      }
    },
    async getNotificationList() {
      try {
        const { data } = await this.$http.get("notification/list", {
          params: { page: this.page - 1, limit: this.limit },
        });
        this.desserts = data.data;
        this.notReaded = data.data.unreadCount;
        this.total = data.data.total;
        this.$store.state.user.notificationCount = this.notReaded;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async next() {
      this.paginationLoading = true;
      try {
        await this.getNotificationList();
      } catch (e) {
        console.log(e);
      } finally {
        this.paginationLoading = false;
      }
    },
  },
  mounted() {
    this.getNotificationList();
    // this.connectWebSocket();
  },
  beforeDestroy() {
    SocketService.disconnect();
  },
};
</script>

<style scoped>
@media (max-width: 740px) {
  .notification-card {
    display: flex;
    flex-direction: column;
    gap: 10px !important;
  }
  .vl {
    height: 1px !important;
    width: 100% !important;
    margin-top: 0 !important;
    border: 1px solid #dfe2e9;
  }
}
.vl {
  height: 40px;
  margin-top: 14px;
  border-left: 1px solid #dfe2e9;
}

h3.small-title {
  color: #48545d;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

p.ptitle {
  color: #7a889b;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0;
  margin-top: 14px;
}

a.phone {
  color: #21292f;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;
}

a.link {
  color: #2bbbde;
  font-family: "Rubik", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;
}

.telegram-link {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 5px;
}

.global_actions {
  padding: 10px;
  gap: 20px;
}

.global_actions div {
  cursor: pointer;
  padding: 7px;
  border-radius: 50%;
  transition: 0.3s all ease;
}

.global_actions div:hover {
  background: #d7d7d7;
}

.readNotification {
  font-weight: 400 !important;
  color: gray;
}
</style>
